import { useEffect } from 'react'
import { ChertoExperiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import { isFlashHotelOffer } from 'lib/offer/offerTypes'
import { isMaldivesCharterBundleOffer } from 'lib/charterFlights/charterBundleOfferPageUtils'
import OfferPageSignUpWall from 'components/Common/OfferPageSignUpWall'
import FlashOfferSignUpContent from './FlashOfferSignUpContent'
import { useInView } from 'react-intersection-observer'

const CHARTER_OFFER_OPTIONS = { requireFlightsEnabled: false }
const WALL_VISIBILITY_OPTIONS = { triggerOnce: true }
const MANUAL_ACTIVATION_OPTIONS = { canActivate: false }

interface Props {
  offer: App.HotelOffer
  packageView: App.OfferPackageOptionView
  saveUpToPercent?: number
  checkInDate?: string
}

/** Activate only after the eligible wall first enters the viewport. */
function FlashOfferSignUpWall({ offer, packageView, saveUpToPercent, checkInDate }: Props) {
  const eligible = isFlashHotelOffer(offer) && !isMaldivesCharterBundleOffer(offer, true, CHARTER_OFFER_OPTIONS) && !!packageView.package
  const { ref, inView } = useInView(WALL_VISIBILITY_OPTIONS)
  const { isTurnedOn, variation, triggerActivation } = useExperiment(
    ChertoExperiments.croFlashOfferPageSignUpModal,
    MANUAL_ACTIVATION_OPTIONS,
  )

  useEffect(() => {
    if (eligible && inView && isTurnedOn) {
      triggerActivation()
    }
  }, [eligible, inView, isTurnedOn, triggerActivation])

  return <OfferPageSignUpWall
    ref={ref}
    offerType="hotel"
    saveUpToPercent={saveUpToPercent}
    content={eligible && variation === 'variant' ? <FlashOfferSignUpContent
      offer={offer}
      pkg={packageView.package}
      packagePricing={packageView.pricing}
      packageMemberPricing={packageView.memberPricing}
      checkInDate={checkInDate}
    /> : undefined}
  />
}

export default FlashOfferSignUpWall
